<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Loader from "@/router/views_mobagile/components/loader.vue";
import Multiselect from "@vueform/multiselect";
import api from "@/axios";
import moment from "moment/moment";
import Swal from "sweetalert2";
import { nextTick } from "vue";
import { getBaseUrl } from "@/helpers/baseUrl";
import { useMagicKeys, whenever } from "@vueuse/core";
import SignaturePadModal from './components/SignaturePadModal.vue';

export default {
  name: "RomaneioColetorEditar",
  components: { Layout, PageHeader, Loader, Multiselect, SignaturePadModal },

  data() {
    return {
      tamanhoTela: 0,
      updating: true,
      activeTab: 0,

      // Romaneio
      wmsRomaneioData: {},
      transpData: {},
      empresaData: {},
      idData: 0,

      // Documentos
      pedidosData: [],
      selecionarTodos: false,
      totalSelecionado: 0,

      // Expedição/Volumes
      wmsRomaOsListData: [],
      wmsRomaOsListDataLidas: [],
      totalEtiquetas: 0,
      totalEtiquetasLidas: 0,
      scanEtiquetaInput: '',

      // Volumes de OS
      wmsOsVolumesData: [],
      wmsOsVolumeData: {},
      somaQtdVolumes: 0,
      somaPesoVolumes: 0,
      idWmsOsSelecionado: null,
      loadingWmsVolume: false,

      // PLP Correios
      movPlpLoteData: {
        formato: '2',
        layprint: 'LINEAR_100_150',
        compinf: 1,
        pesoinf: 1,
        altuinf: 1,
        larginf: 1,
        prevpost: moment().format("YYYY-MM-DD"),
        servico: null,
      },
      movPlpLotesData: null,
      movPlpsData: [],
      loadingMovPlp: false,
      submittedMovPlpLote: false,
      totalCorreioServ: 0,

      // Modais
      showModalTransp: false,
      showModalObs: false,
      showModalRota: false,
      showModalDetalhes: false,
      showModalAddPedido: false,
      showModalAddWmsOs: false,
      showModalVolume: false,
      showModalPLPCorreios: false,
      showModalImprimirEtiqLogistica: false,
      showModalEtiquetaLogistica: false,
      showModalAnexo: false,
      showModalAnexoList: false,
      showModalColeta: false,

      // Transportadoras
      loadingTransp: false,
      dtListPesqTransp: null,

      // Adicionar Pedido
      modoPesq: 'chavenf',
      chaveAddNf: '',
      submittedAddPedido: false,
      idWmsOs: null,
      submittedAddWmsOs: false,

      // Anexos
      mediasAnexoData: null,
      descranexo: '',
      submittedAnexo: false,
      dropzoneFile: '',
      loadingFiles: false,
      pdfUrl: '',

      // Etiqueta logística
      chaveEtiqLogistica: '',

      // Coleta
      listaSolicitacaoColeta: [],
      loadingDisparaColeta: false,

      // Corr. Serviço pesquisa
      dtListPesqCorreioServico: null,

      errosValid: null,
      qtdTotalDocumentos: 0,
      qtdTotalVolumes: 0,
      naoFinalizaAuto: false,
      travaAddRemov: false,
      imprimeSemTravaStatus: false,
      usuarioEhAdmin: false,

      mostrarAssinatura: false,
      temAssinatura: false,
      temAssinaturaConferente: false,
      temFoto: false,
      tipoAssinatura: 'motorista',
      filaAssinaturas: [],
    };
  },

  computed: {
    statusBadgeClass() {
      const s = this.wmsRomaneioData.status;
      return `badge-${s}`;
    },
    itensPendentes() {
      return this.wmsRomaOsListData || [];
    },
    itensLidos() {
      return this.wmsRomaOsListDataLidas || [];
    },
  },

  mounted() {
    this.tamanhoTela = window.innerWidth;

    const keys = useMagicKeys();
    whenever(keys.alt_e, () => {
      if (this.activeTab === 2) this.$refs.scanInput?.focus();
    });
    whenever(keys.alt_r, () => {
      if (this.activeTab === 2) this.reiniciarExpedicao();
    });
    whenever(keys.alt_z, () => {
      if (this.activeTab === 2) this.finalizarExpedicao();
    });

    let rota = this.$route.path;
    let ultimaBarra = rota.lastIndexOf('/');
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1));
    }

    if (this.idData > 0) {
      this.carregarDados();
    } else {
      this.updating = false;
    }
  },

  methods: {
    /* ───────────────────────────────────────────────
       CARREGAMENTO DE DADOS
    ─────────────────────────────────────────────── */
    carregarDados() {
      this.updating = true;
      api.get(`${getBaseUrl()}api/wmsromaneio`, {
        params: { iddata: this.idData }
      }).then((res) => {
        if (!Array.isArray(res.data) || !res.data[0]) {
          Swal.fire({ icon: 'error', title: 'Erro', text: res.data?.error ?? 'Romaneio não encontrado', timer: 2000, showConfirmButton: false });
          this.updating = false;
          return;
        }
        this.wmsRomaneioData = res.data[0];
        this.transpData = res.data[1];
        this.pedidosData = res.data[2] || [];
        this.movPlpLotesData = res.data[3];
        this.movPlpsData = res.data[4] || [];
        if (res.data[6]) this.totalCorreioServ = res.data[6];
        if (res.data[7]) this.empresaData = res.data[7];
        this.qtdTotalDocumentos = res.data[8] || 0;
        this.qtdTotalVolumes = res.data[9] || 0;
        this.naoFinalizaAuto = !!res.data[10];
        this.travaAddRemov = !!res.data[11];
        this.usuarioEhAdmin = res.data[12] === 'admin';
        this.imprimeSemTravaStatus = !!res.data[13];

        if (this.transpData && this.transpData.servtransp) {
          this.movPlpLoteData.servico = this.transpData.servtransp;
        }

        this.carregarMediaInfo();
        this.updating = false;
      });
    },

    carregarExpedicao() {
      api.get(`${getBaseUrl()}api/wmsromaexped`, {
        params: { iddata: this.idData }
      }).then((res) => {
        this.wmsRomaOsListData = this.filtrarDisponiveis(res.data[6] || []);
        this.wmsRomaOsListDataLidas = this.filtrarDespachados(res.data[6] || []);
        this.totalEtiquetas = this.wmsRomaOsListData.length;
        this.totalEtiquetasLidas = this.wmsRomaOsListDataLidas.length;
      });
    },

    onTabChange(tab) {
      this.activeTab = tab;
      if (tab === 2) {
        this.carregarExpedicao();
        nextTick(() => {
          this.$refs.scanInput?.focus();
        });
      }
    },

    /* ───────────────────────────────────────────────
       FILTROS DE EXPEDIÇÃO
    ─────────────────────────────────────────────── */
    filtrarDisponiveis(arr) {
      return arr.filter(v => !v.dtconfer);
    },
    filtrarDespachados(arr) {
      return arr.filter(v => !!v.dtconfer);
    },

    /* ───────────────────────────────────────────────
       SCAN ETIQUETA (TAB 2)
    ─────────────────────────────────────────────── */
    informouEtiquetaNova() {
      const inputEtiqueta = this.scanEtiquetaInput;
      if (!inputEtiqueta) return;

      const encontradaEtiqueta = this.wmsRomaOsListData.find((value) => {
        return (
          value.etiqueta.includes(inputEtiqueta) ||
          value.etiqueta.includes(inputEtiqueta.replace(/^0/, '')) ||
          inputEtiqueta.includes(value.etiqueta) ||
          inputEtiqueta.replace(/^0/, '').includes(value.etiqueta)
        );
      });

      let existeNasLidas = this.wmsRomaOsListDataLidas.some(v => v.etiqueta === inputEtiqueta);

      if (encontradaEtiqueta && !existeNasLidas) {
        this.wmsRomaOsListDataLidas.push(encontradaEtiqueta);
        let idx = this.wmsRomaOsListData.findIndex(i => i.etiqueta === encontradaEtiqueta.etiqueta);
        if (idx !== -1) this.wmsRomaOsListData.splice(idx, 1);
        this.totalEtiquetasLidas = this.wmsRomaOsListDataLidas.length;
        this.totalEtiquetas = this.wmsRomaOsListData.length;

        if (this.wmsRomaOsListData.length === 0 && !this.naoFinalizaAuto) {
          api.post(`${getBaseUrl()}api/wmsosromaconfembnova`, {
            iddata: this.idData,
            lista_etiquetas: this.wmsRomaOsListDataLidas
          }).then((res) => {
            let success = res.data[0];
            if (success) {
              Swal.fire({ position: "top-end", icon: "success", title: "Expedição finalizada!", showConfirmButton: false, timer: 1500 }).then(() => {
                api.post(`${getBaseUrl()}api/solicitacoleta`, { idData: this.idData }).then((r) => {
                  if (r.data.success) {
                    Swal.fire({ position: "top-end", icon: "success", title: r.data.mensagem, showConfirmButton: false, timer: 2500 });
                  } else {
                    Swal.fire({ position: "center", icon: "error", title: r.data.mensagem, showConfirmButton: true });
                  }
                });
              });
            } else {
              Swal.fire({ position: "top-end", icon: "error", title: "Erro ao finalizar volumes!", showConfirmButton: false, timer: 1500 }).then(() => this.carregarExpedicao());
            }
          });
        } else if (this.wmsRomaOsListData.length === 0 && this.naoFinalizaAuto) {
          Swal.fire({ position: "top-end", icon: "success", title: "Todos os volumes lidos!", showConfirmButton: false, timer: 1500 });
          this.scanEtiquetaInput = '';
        } else {
          this.scanEtiquetaInput = '';
          this.$refs.scanInput?.focus();
        }
      } else {
        Swal.fire({ position: "top-end", icon: "warning", title: "Etiqueta não disponível ou já lida.", showConfirmButton: false, timer: 1500 });
        this.scanEtiquetaInput = '';
      }
    },

    separarTodos() {
      Swal.fire({
        position: "center", icon: "question",
        title: "Separar todos os volumes?",
        confirmButtonText: "Confirmar", cancelButtonText: "Cancelar",
        showCancelButton: true, showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.post(`${getBaseUrl()}api/wmsosromaconftodos`, { iddata: this.idData }).then((res) => {
            if (res.data.success) {
              Swal.fire({ position: "top-end", icon: "success", title: res.data.message, showConfirmButton: false, timer: 3000 }).then(() => {
                api.post(`${getBaseUrl()}api/solicitacoleta`, { idData: this.idData }).then((r) => {
                  if (r.data.success) {
                    Swal.fire({ position: "top-end", icon: "success", title: r.data.mensagem, showConfirmButton: false, timer: 2500 });
                  } else {
                    Swal.fire({ position: "center", icon: "error", title: r.data.mensagem, showConfirmButton: true });
                  }
                });
                this.carregarExpedicao();
              });
            } else {
              Swal.fire({ position: "top-end", icon: "error", title: "Falha ao separar todos!", showConfirmButton: false, timer: 2000 }).then(() => this.carregarExpedicao());
            }
          });
        }
      });
    },

    reiniciarExpedicao() {
      Swal.fire({
        position: "center", icon: "question",
        title: "Reiniciar Expedição",
        text: "Esta operação é irreversível!",
        confirmButtonText: "Confirmar", cancelButtonText: "Cancelar",
        showCancelButton: true, showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.post(`${getBaseUrl()}api/wmsosromareinicia`, { iddata: this.idData }).then((res) => {
            this.wmsRomaOsListData = this.filtrarDisponiveis(res.data[0] || []);
            this.wmsRomaOsListDataLidas = [];
            this.totalEtiquetas = this.wmsRomaOsListData.length;
            this.totalEtiquetasLidas = 0;
            Swal.fire({ position: "top-end", icon: "success", title: "Expedição reiniciada!", showConfirmButton: false, timer: 1500 });
          });
        }
      });
    },

    finalizarExpedicao() {
      Swal.fire({
        position: "center", icon: "question",
        title: "Finalizar Expedição",
        text: "Volumes pendentes poderão ser finalizados depois.",
        confirmButtonText: "Confirmar", cancelButtonText: "Cancelar",
        showCancelButton: true, showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.post(`${getBaseUrl()}api/wmsosromaconfembnova`, {
            iddata: this.idData,
            lista_etiquetas: this.wmsRomaOsListDataLidas
          }).then((res) => {
            let success = res.data[0];
            if (success) {
              Swal.fire({ position: "top-end", icon: "success", title: "Finalizado!", showConfirmButton: false, timer: 1500 }).then(() => {
                this.$router.push(`/wmsromaneio/editar/${this.idData}`);
              });
            } else {
              Swal.fire({ position: "top-end", icon: "error", title: "Erro ao finalizar!", showConfirmButton: false, timer: 1500 }).then(() => this.carregarExpedicao());
            }
          });
        }
      });
    },

    /* ───────────────────────────────────────────────
       TAB INFO – SALVAR
    ─────────────────────────────────────────────── */
    salvar() {
      this.updating = true;
      this.errosValid = [];
      api.post(`${getBaseUrl()}api/wmsromaneio`, {
        wmsromaneioData: this.wmsRomaneioData
      }).then(() => {
        this.updating = false;
        Swal.fire({ position: "top-end", icon: "success", title: "Salvo com sucesso!", showConfirmButton: false, timer: 1500 });
        this.carregarDados();
      }).catch((err) => {
        this.updating = false;
        const erros = err.response?.data?.errors || {};
        this.errosValid = Object.keys(erros).map(k => ({ titulo: k, mensagem: erros[k] }));
      });
    },

    confirmarObs() {
      this.showModalObs = false;
      this.salvar();
    },

    confirmarRota() {
      this.showModalRota = false;
      this.salvar();
    },

    confirmarDetalhes() {
      this.showModalDetalhes = false;
      this.salvar();
    },

    /* ───────────────────────────────────────────────
       TRANSPORTADORA
    ─────────────────────────────────────────────── */
    pesqTransp(evt) {
      if (evt.length > 1) {
        this.loadingTransp = true;
        api.get(`${getBaseUrl()}api/transpesq`, { params: { q: evt } }).then((res) => {
          this.dtListPesqTransp = res.data;
          this.loadingTransp = false;
        });
      }
    },

    escolheuTransp() {
      this.loadingTransp = true;
      api.get(`${getBaseUrl()}api/clicnpj`, { params: { cnpjdata: this.wmsRomaneioData.transp } }).then((res) => {
        this.transpData = res.data[0];
        this.movPlpLoteData.servico = this.transpData.servtransp ?? null;
        this.loadingTransp = false;
        this.showModalTransp = false;
      });
      this.salvar();
    },

    confirmarTransp() {
      this.showModalTransp = false;
      this.salvar();
    },

    /* ───────────────────────────────────────────────
       DOCUMENTOS / PEDIDOS – AÇÕES
    ─────────────────────────────────────────────── */
    selecionarItem(item) {
      item.selecionado = !item.selecionado;
      this.atualizarTotalSelecionado();
    },

    selecionaTodos() {
      this.pedidosData.forEach(v => { v.selecionado = this.selecionarTodos; });
      this.atualizarTotalSelecionado();
    },

    atualizarTotalSelecionado() {
      this.totalSelecionado = this.pedidosData.filter(v => v.selecionado).length;
    },

    confirmarAddPedido() {
      this.submittedAddPedido = true;
      if (!this.chaveAddNf) return;
      api.post(`${getBaseUrl()}api/wmsromaadped`, {
        iddata: this.idData,
        nfadd: this.chaveAddNf,
        modopesq: this.modoPesq
      }).then((res) => {
        if (!res.data.success && res.data.error) {
          Swal.fire({ position: "top-end", icon: "error", title: res.data.error, showConfirmButton: false, timer: 1500 });
          this.chaveAddNf = null;
        } else if (res.data.success) {
          Swal.fire({ position: "top-end", icon: "success", title: res.data.message, showConfirmButton: false, timer: 1500 }).then(() => {
            this.chaveAddNf = null;
            this.showModalAddPedido = false;
            this.carregarDados();
          });
        } else {
          Swal.fire({
            position: "center", icon: "warning", title: res.data.message,
            showConfirmButton: true, showCancelButton: true,
            confirmButtonText: 'Mover', cancelButtonText: 'Não'
          }).then((escolha) => {
            if (escolha.isConfirmed) {
              api.post(`${getBaseUrl()}api/wmsromatransfnota`, { iddata: this.idData, nfadd: this.chaveAddNf, modopesq: this.modoPesq }).then((r) => {
                this.chaveAddNf = null;
                Swal.fire({ position: "top-end", icon: r.data.success ? "success" : "error", title: r.data.success ? r.data.message : r.data.error, showConfirmButton: false, timer: 1500 }).then(() => {
                  this.showModalAddPedido = false;
                  this.carregarDados();
                });
              });
            }
          });
        }
      });
    },

    confirmarAddWmsOs() {
      this.submittedAddWmsOs = true;
      if (!this.idWmsOs) return;
      api.post(`${getBaseUrl()}api/wmsromawmsos`, {
        iddata: this.idData,
        wmsos_id: this.idWmsOs
      }).then((res) => {
        if (res.data.success) {
          Swal.fire({ position: "top-end", icon: "success", title: res.data.message, showConfirmButton: false, timer: 1500 }).then(() => {
            this.idWmsOs = null;
            this.showModalAddWmsOs = false;
            this.carregarDados();
          });
        } else {
          Swal.fire({ position: "top-end", icon: "error", title: res.data.error || 'Erro ao adicionar OS', showConfirmButton: false, timer: 1500 });
        }
      });
    },

    imprimirMiniDanfeItem(item) {
      api.post(`${getBaseUrl()}api/impminidanferomaneio`, {
        idData: this.idData,
        listaPedidos: [item]
      }).then((res) => {
        const icon = res.data.success ? 'success' : 'warning';
        Swal.fire({ position: "top-end", icon, title: res.data.message, showConfirmButton: false, timer: 2000 });
      });
    },

    imprimirMiniDanfeSelecionados() {
      const selecionados = this.pedidosData.filter(v => v.selecionado);
      if (selecionados.length === 0) {
        Swal.fire({ position: "center", icon: "warning", title: "Nenhum pedido selecionado!", showConfirmButton: false, timer: 2000 });
        return;
      }
      api.post(`${getBaseUrl()}api/impminidanferomaneio`, {
        idData: this.idData,
        listaPedidos: selecionados
      }).then((res) => {
        Swal.fire({ position: "top-end", icon: res.data.success ? "success" : "warning", title: res.data.message, showConfirmButton: false, timer: 2000 }).then(() => {
          this.pedidosData.forEach(v => { v.selecionado = false; });
          this.selecionarTodos = false;
          this.totalSelecionado = 0;
        });
      });
    },

    imprimirZipDanfe() {
      const selecionados = this.pedidosData.filter(v => v.selecionado).map(v => v.id);
      if (selecionados.length === 0) {
        Swal.fire({ position: "center", icon: "warning", title: "Selecione pelo menos 1 nota!", showConfirmButton: false, timer: 2500 });
        return;
      }
      api.post(`${getBaseUrl()}api/romaXml2Danfe`, { listItens: selecionados }, { responseType: 'blob' }).then((res) => {
        const blob = new Blob([res.data], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `danfes_romaneio_${this.idData}.zip`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      });
    },

    imprimirEtiqLogistica(chave, wmsos_id) {
      api.get(`${getBaseUrl()}api/imprimiretiqlogistica`, { params: { chave, wmsos_id } }).then((res) => {
        if (res.data.success) {
          this.pdfUrl = `data:application/pdf;base64,${res.data.base64}`;
          this.showModalEtiquetaLogistica = true;
        } else {
          Swal.fire({ position: "top-end", icon: "error", title: res.data.message, showConfirmButton: false, timer: 3000 });
        }
      });
    },

    buscarEtiqLogistica() {
      if (!this.chaveEtiqLogistica) return;
      const ped = this.pedidosData.find(p => p.chave && p.chave.includes(this.chaveEtiqLogistica));
      if (ped) {
        this.imprimirEtiqLogistica(ped.chave, ped.wmsosid || ped.wmsos_id);
      } else {
        Swal.fire({ position: "top-end", icon: "warning", title: "Documento não encontrado!", showConfirmButton: false, timer: 1500 });
      }
    },

    disparaColeta() {
      const count = this.pedidosData.filter(v => v.selecionado).length;
      if (count === 0) {
        Swal.fire({ position: "center", icon: "warning", title: "Nenhum pedido selecionado!", showConfirmButton: false, timer: 2000 });
        return;
      }
      this.loadingDisparaColeta = true;
      api.post(`${getBaseUrl()}api/solicitacoleta`, { idData: this.wmsRomaneioData.id }).then((res) => {
        this.loadingDisparaColeta = false;
        Swal.fire({
          position: "top-end",
          icon: res.data.success ? "success" : "error",
          title: res.data.mensagem,
          showConfirmButton: !res.data.success,
          timer: res.data.success ? 5000 : undefined
        }).then(() => this.carregarDados());
      });
    },

    dispararColetaIndividual(item) {
      api.post(`${getBaseUrl()}api/solicitacoletauni`, { idData: this.idData, numnf: item.codigo }).then((res) => {
        Swal.fire({ position: "top-end", icon: res.data.success ? "info" : "error", title: res.data.mensagem, showConfirmButton: false, timer: 2000 }).then(() => this.carregarDados());
      });
    },

    desvRomPed(iddata) {
      Swal.fire({
        position: 'center', icon: 'question', title: 'Desvincular NF',
        text: 'Remover a NF-e do romaneio atual?',
        showConfirmButton: true, showCancelButton: true
      }).then((result) => {
        if (result.value) {
          api.get(`${getBaseUrl()}api/wmsromadesv`, { params: { iddata } }).then((res) => {
            if (res.data?.error) {
              Swal.fire({ position: "top-end", icon: "error", title: "Operação não permitida", showConfirmButton: false, timer: 2000 });
              return;
            }
            Swal.fire({ position: "top-end", icon: "success", title: res.data, showConfirmButton: false, timer: 1500 });
            this.carregarDados();
          });
        }
      });
    },

    deletarRomPed(iddata) {
      Swal.fire({
        position: "center", icon: "question", title: "Remover Associação",
        text: "Operação irreversível, continuar?",
        confirmButtonText: "Confirmar", cancelButtonText: "Cancelar",
        showCancelButton: true, showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.get(`${getBaseUrl()}api/wmsromadesa`, { params: { iddata } }).then((res) => {
            if (res.data?.error) {
              Swal.fire({ position: "top-end", icon: "error", title: "Operação não permitida", showConfirmButton: false, timer: 2000 });
              return;
            }
            Swal.fire({ position: "top-end", icon: "success", title: "Removido com sucesso!", showConfirmButton: false, timer: 1500 });
            this.carregarDados();
          });
        }
      });
    },

    abrirWmsOs(wmsosid) {
      const routeData = this.$router.resolve(`/wmsos/saidaeditarnova/${wmsosid}`);
      window.open(routeData.href, '_blank');
    },

    retryBuscarVolumesTagia(data) {
      Swal.fire({
        position: "center", icon: "question", title: "Retentar busca Tagia",
        text: `Retentar para NF ${data.codigo}?`,
        confirmButtonText: "Sim", cancelButtonText: "Cancelar",
        showCancelButton: true, showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true;
          api.post(`${getBaseUrl()}api/wmsromatagiaretry`, { wmsos_id: data.wmsosid || data.wmsos_id }).then((res) => {
            this.updating = false;
            if (res.data.success) {
              Swal.fire({ position: "top-end", icon: "success", title: res.data.message, showConfirmButton: false, timer: 2500 });
              this.carregarDados();
            } else {
              Swal.fire({ position: "top-end", icon: "error", title: "Falha na busca Tagia", text: res.data.error, showConfirmButton: true });
            }
          });
        }
      });
    },

    /* ───────────────────────────────────────────────
       VOLUMES
    ─────────────────────────────────────────────── */
    abrirModalVol(data) {
      const pedido = this.pedidosData.find(p => (p.wmsosid ?? p.wmsos_id) === (data.wmsosid ?? data.wmsos_id));
      this.idWmsOsSelecionado = pedido ? (pedido.wmsosid ?? pedido.wmsos_id) : null;
      if (pedido && pedido.volumes) {
        this.wmsOsVolumesData = pedido.volumes;
        let totalVols = 0, pesoVols = 0;
        this.wmsOsVolumesData.forEach(v => { totalVols += v.qtd; pesoVols += v.peso; });
        this.somaQtdVolumes = totalVols;
        this.somaPesoVolumes = pesoVols;
      }
      this.showModalVolume = true;
    },

    confirmarVolume() {
      if (this.wmsOsVolumeData.qtd > 0 && this.wmsOsVolumeData.peso > 0) {
        this.loadingWmsVolume = true;
        api.post(`${getBaseUrl()}api/wmsosconfvol`, {
          idwmsos: this.idWmsOsSelecionado,
          qtd: this.wmsOsVolumeData.qtd,
          peso: this.wmsOsVolumeData.peso,
        }).then((res) => {
          this.loadingWmsVolume = false;
          if (res.data.error) {
            Swal.fire({ position: "top-end", icon: "error", title: res.data.error, showConfirmButton: false, timer: 3000 });
          } else {
            Swal.fire({ position: "top-end", icon: "success", title: "Volume cadastrado!", showConfirmButton: false, timer: 1500 });
            this.wmsOsVolumesData = res.data[0];
            let totalVols = 0, pesoVols = 0;
            this.wmsOsVolumesData.forEach(v => { totalVols += v.qtd; pesoVols += v.peso; });
            this.somaQtdVolumes = totalVols;
            this.somaPesoVolumes = pesoVols;
          }
          this.wmsOsVolumeData = {};
        });
      }
    },

    imprimirEtiquetasVolume(data) {
      window.open(`${getBaseUrl()}api/wmsosvoletiqstra?id=${data.wmsosid || data.wmsos_id}`, '_blank');
    },

    /* ───────────────────────────────────────────────
       PLP CORREIOS
    ─────────────────────────────────────────────── */
    plpCorreios() {
      if (this.totalCorreioServ > 0) {
        const selecionados = this.pedidosData.filter(v => v.selecionado);
        if (selecionados.length > 50) {
          Swal.fire({ position: "top-end", icon: "warning", title: "Limite máximo de 50 NFs.", showConfirmButton: false, timer: 4500 });
          return;
        }
        if (this.transpData && this.transpData.apirastreio !== 'CORREIOS') {
          Swal.fire({ position: "top-end", icon: "warning", title: "Transportadora não possui serviço Correios.", showConfirmButton: false, timer: 4500 });
          return;
        }
        this.showModalPLPCorreios = true;
      } else {
        Swal.fire({ position: "top-end", icon: "warning", title: "Nenhum serviço disponível para Correios.", showConfirmButton: false, timer: 4500 });
      }
    },

    async confPLPLoteCorreios() {
      const pedSelecionados = this.pedidosData.filter(v => v.selecionado).map(v => v.id);
      if (pedSelecionados.length === 0) {
        Swal.fire({ position: "top-end", icon: "error", title: "Nenhum movimento selecionado!", showConfirmButton: false, timer: 3500 });
        return;
      }
      if (this.movPlpLoteData.formato && this.movPlpLoteData.servico &&
          this.movPlpLoteData.compinf && this.movPlpLoteData.pesoinf &&
          this.movPlpLoteData.altuinf && this.movPlpLoteData.larginf &&
          this.movPlpLoteData.prevpost) {
        this.loadingMovPlp = true;
        api.post(`${getBaseUrl()}api/movsplpcorreios`, {
          idsData: pedSelecionados,
          movPlpLoteData: this.movPlpLoteData,
          wmsRomaIdData: this.idData,
          loteData: null
        }).then(res => {
          this.loadingMovPlp = false;
          if (res.data[0] === 'erro') {
            Swal.fire({ position: "top-end", icon: "error", title: 'Erro', text: res.data[1], showConfirmButton: false, timer: 3500 });
          } else {
            this.movPlpLotesData = res.data[0];
            this.movPlpsData = res.data[1];
            Swal.fire({ position: "top-end", icon: "success", title: "Registro criado!", showConfirmButton: false, timer: 1500 });
          }
          this.carregarDados();
        }).catch(err => {
          this.loadingMovPlp = false;
          Swal.fire({ position: "top-end", icon: "error", title: 'Erro', text: err.response?.data?.[0]?.erro, showConfirmButton: false, timer: 3500 });
        });
      }
    },

    cancelarMovPlp(iddata) {
      Swal.fire({
        position: "center", icon: "question", title: `Cancelar PLP ${iddata}`,
        text: "Operação irreversível!",
        confirmButtonText: "Confirmar", cancelButtonText: "Cancelar",
        showCancelButton: true, showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingMovPlp = true;
          api.get(`${getBaseUrl()}api/movplpcanc`, { params: { iddata } }).then(() => {
            this.loadingMovPlp = false;
            this.movPlpsData.forEach(v => { if (v.id === iddata) { v.status = '5'; v.descstatus = 'Cancelado'; v.recibo = null; } });
            Swal.fire({ position: "top-end", icon: "success", title: "Cancelado com sucesso!", showConfirmButton: false, timer: 1500 });
          });
        }
      });
    },

    solicitarRotuloLote(idLote) {
      if (!idLote) return;
      this.loadingMovPlp = true;
      api.get(`${getBaseUrl()}api/movplprotulote`, { params: { idlote: idLote, layout: this.movPlpLoteData.layprint } }).then((res) => {
        this.loadingMovPlp = false;
        this.movPlpsData = res.data[0];
        Swal.fire({ position: "top-end", icon: "success", title: "Rótulo solicitado!", showConfirmButton: false, timer: 1500 });
        this.carregarDados();
      });
    },

    consultarTodosObjetos(idLote) {
      this.loadingMovPlp = true;
      api.get(`${getBaseUrl()}api/movplpconsobjlote`, { params: { iddata: idLote } }).then((res) => {
        if (res.data[0] === 'erro') {
          Swal.fire({ position: "top-end", icon: "error", title: res.data[1], showConfirmButton: false, timer: 3500 });
          this.loadingMovPlp = false;
        } else {
          this.movPlpsData = res.data[0];
          Swal.fire({ position: "top-end", icon: "success", title: "Consulta realizada!", showConfirmButton: false, timer: 2500 });
          this.solicitarRotuloLote(idLote);
        }
      });
    },

    /* ───────────────────────────────────────────────
       TAB AÇÕES
    ─────────────────────────────────────────────── */
    finalizar() {
      if (!this.pedidosData || this.pedidosData.length === 0) {
        Swal.fire({ position: "top-end", icon: "warning", title: "Mínimo de uma OS associada para finalizar.", showConfirmButton: false, timer: 1500 });
        return;
      }
      Swal.fire({
        position: "center", icon: "question", title: "Finalizar Romaneio",
        text: "Esta operação é irreversível!",
        confirmButtonText: "Confirmar", cancelButtonText: "Cancelar",
        showCancelButton: true, showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          Swal.fire({
            position: "center", icon: "question",
            title: "Volumes pendentes serão concluídos automaticamente!",
            text: "Confirmar?",
            confirmButtonText: "Confirmar", cancelButtonText: "Cancelar",
            showCancelButton: true, showConfirmButton: true,
          }).then(result2 => {
            if (result2.value) {
              this.loadingFiles = true;
              api.post(`${getBaseUrl()}api/wmsromaconf`, { iddata: this.idData }).then((res) => {
                Swal.fire({ position: "top-end", icon: "success", title: res.data[1], showConfirmButton: false, timer: 3500 }).then(() => {
                  api.post(`${getBaseUrl()}api/solicitacoleta`, { idData: this.idData }).then((r) => {
                    Swal.fire({
                      position: "top-end", icon: r.data.success ? "success" : "error",
                      title: r.data.mensagem, showConfirmButton: !r.data.success, timer: r.data.success ? 2500 : undefined
                    });
                  });
                });
                this.loadingFiles = false;
                this.carregarDados();
              });
            }
          });
        }
      });
    },

    cancelar() {
      Swal.fire({
        position: "center", icon: "question", title: "Cancelar Romaneio",
        text: "Operação irreversível!",
        confirmButtonText: "Confirmar", cancelButtonText: "Cancelar",
        showCancelButton: true, showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.post(`${getBaseUrl()}api/wmsromacanc`, { iddata: this.idData }).then(() => {
            Swal.fire({ position: "top-end", icon: "success", title: "Romaneio cancelado!", showConfirmButton: false, timer: 1500 });
            this.carregarDados();
          });
        }
      });
    },

    gerarWmsOs() {
      this.updating = true;
      api.get(`${getBaseUrl()}api/romawmsos`, { params: { idData: this.wmsRomaneioData.id } }).then(() => {
        this.carregarDados();
      });
    },

    reenvioEmailEmbarque() {
      api.get(`${getBaseUrl()}api/wmsromareenvmail`, { params: { wmsromaneio_id: this.idData } }).then((res) => {
        const icon = res.data.envios_com_erro.length === 0 ? 'success' : 'warning';
        Swal.fire({ icon, position: 'top-end', text: res.data.message, showConfirmButton: false, timer: 8000 });
      });
    },

    async imprimirRomaneio() {
      if (!this.imprimeSemTravaStatus && this.wmsRomaneioData.status != 'EQ' && this.wmsRomaneioData.status != 'FN') {
        Swal.fire({ title: 'Romaneio não finalizado, favor finalizar o romaneio antes de imprimir' });
        return;
      }

      const icon = (ok) => ok ? '✅' : '⚠️';
      const cor  = (ok) => ok ? '#27ae60' : '#e67e22';
      const ambosAssinados = this.temAssinatura && this.temAssinaturaConferente;

      const statusHtml = `
        <div style="margin-top:8px; font-size:13px; text-align:left; display:inline-block;">
          <div style="color:${cor(this.temAssinaturaConferente)};">
            ${icon(this.temAssinaturaConferente)} Conferente
          </div>
          <div style="color:${cor(this.temAssinatura)}; margin-top:4px;">
            ${icon(this.temAssinatura)} Motorista
          </div>
        </div>`;

      const confirmText = ambosAssinados ? '✍️ Re-assinar' : '✍️ Assinar';

      const result = await Swal.fire({
        title: 'Imprimir Romaneio',
        html: statusHtml,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: confirmText,
        denyButtonText: '🖨️ Imprimir em Papel',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: ambosAssinados ? '#7f8c8d' : '#27ae60',
        denyButtonColor: '#2980b9',
      });

      if (result.isConfirmed) {
        this.filaAssinaturas = [];
        if (!this.temAssinaturaConferente || ambosAssinados) this.filaAssinaturas.push('conferente');
        if (!this.temAssinatura || ambosAssinados) this.filaAssinaturas.push('motorista');
        this.proximaAssinatura();
      } else if (result.isDenied) {
        await this.baixarPdf();
        await this.perguntarFoto();
      }
    },

    imprimirSepPedPorPage() {
      api.get(`${getBaseUrl()}api/relromasep01`, { params: { iddata: this.idData }, responseType: 'blob' }).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Separacao_pag_${this.idData}.pdf`);
        document.body.appendChild(link);
        link.click();
      });
    },

    imprimirSep() {
      api.get(`${getBaseUrl()}api/relromasep02`, { params: { iddata: this.idData }, responseType: 'blob' }).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Separacao_${this.idData}.pdf`);
        document.body.appendChild(link);
        link.click();
      });
    },

    imprimirSepAgr() {
      api.get(`${getBaseUrl()}api/relromasep03`, { params: { iddata: this.idData }, responseType: 'blob' }).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Separacao_agr_${this.idData}.pdf`);
        document.body.appendChild(link);
        link.click();
      });
    },

    exportarColeta() {
      api.get(`${getBaseUrl()}api/getcoleta`, { params: { idData: this.idData, export: 1 }, responseType: 'blob' }).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `coleta_${this.idData}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },

    /* Anexos */
    novoAnexo() {
      this.descranexo = '';
      this.submittedAnexo = false;
      this.showModalAnexo = true;
    },

    confAnexo() {
      this.submittedAnexo = true;
      const input = this.$refs.fileInput;
      if (!input || !input.files || !input.files[0]) return;
      this.showModalAnexo = false;
      this.loadingFiles = true;
      const arquivo = input.files[0];
      const formData = new FormData();
      formData.append("iddata", this.idData);
      formData.append("descranexo", this.descranexo);
      formData.append("filename", arquivo.name);
      formData.append("file", arquivo);
      api.post(`${getBaseUrl()}api/wmsromafileanexo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((res) => {
        this.loadingFiles = false;
        Swal.fire({ position: "top-end", icon: res.data.success ? "success" : "error", title: res.data.message, showConfirmButton: false, timer: 2000 });
        if (res.data.success) this.carregarDados();
      });
    },

    visualizarComprovante() {
      api.get(`${getBaseUrl()}api/getromacomprovante`, { params: { iddata: this.wmsRomaneioData.id }, responseType: 'blob' }).then((res) => {
        if (res.data) {
          const fileURL = window.URL.createObjectURL(res.data);
          const link = document.createElement('a');
          link.href = fileURL;
          link.setAttribute('download', `comprovante_romaneio_${this.idData}`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          Swal.fire({ position: 'top-end', icon: 'error', title: 'Comprovante não existente!', showConfirmButton: false, timer: 2000 });
        }
      });
    },

    /* ───────────────────────────────────────────────
       FORMATAÇÃO
    ─────────────────────────────────────────────── */
    formatDecimal(value) {
      if (value) return parseFloat(value).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
      return "0,00";
    },
    formatInteger(value) {
      if (value) return parseFloat(value).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      return 0;
    },
    formatDate(value) {
      return value ? moment(new Date(value)).format("DD/MM/YYYY") : '-';
    },
    formatDateTime(value) {
      return value ? moment(new Date(value)).format("DD/MM/YYYY HH:mm") : '-';
    },

    proximaAssinatura() {
      if (this.filaAssinaturas.length === 0) {
        this.baixarPdf().then(() => this.perguntarFoto());
        return;
      }
      this.tipoAssinatura = this.filaAssinaturas.shift();
      this.mostrarAssinatura = true;
    },

    async aoConfirmarAssinatura(base64) {
      this.mostrarAssinatura = false;
      try {
        await api.post(`${getBaseUrl()}api/wmsromaneioassinatura`, {
          iddata: this.idData,
          assinatura: base64,
          tipo: this.tipoAssinatura,
        });
        if (this.tipoAssinatura === 'motorista') this.temAssinatura = true;
        if (this.tipoAssinatura === 'conferente') this.temAssinaturaConferente = true;
        this.proximaAssinatura();
      } catch (e) {
        Swal.fire({ title: 'Erro ao salvar assinatura', icon: 'error' });
      }
    },

    baixarPdf() {
      return api
        .get(`${getBaseUrl()}api/relroma01`, {
          params: { iddata: this.idData },
          responseType: 'blob',
        })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Relatorio_romaneio_${this.idData}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        });
    },

    async perguntarFoto() {
      const { isConfirmed } = await Swal.fire({
        title: 'Foto Comprovante',
        text: 'Deseja tirar uma foto como comprovante do embarque?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Tirar Foto',
        cancelButtonText: 'Pular',
        confirmButtonColor: '#27ae60',
      });
      if (isConfirmed) {
        this.$refs.inputFoto.click();
      }
    },

    async aoSelecionarFoto(event) {
      const file = event.target.files[0];
      if (!file) return;
      const formData = new FormData();
      formData.append('iddata', this.idData);
      formData.append('foto', file);
      try {
        await api.post(`${getBaseUrl()}api/wmsromaneiofoto`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        this.temFoto = true;
        Swal.fire({ title: 'Foto salva com sucesso!', icon: 'success', timer: 2000, showConfirmButton: false });
      } catch (e) {
        Swal.fire({ title: 'Erro ao salvar foto', icon: 'error' });
      } finally {
        event.target.value = '';
      }
    },

    async carregarMediaInfo() {
      try {
        const res = await api.get(`${getBaseUrl()}api/wmsromaneiomedia`, {
          params: { iddata: this.idData },
        });
        this.temAssinatura           = res.data.temAssinatura;
        this.temAssinaturaConferente = res.data.temAssinaturaConferente;
        this.temFoto                 = res.data.temFoto;
      } catch (e) {
        // silencioso — não bloqueia o carregamento
      }
    },
  },
};
</script>

<template>
<div><!-- root -->
  <!-- ═══════════════════════════════════════
       DESKTOP (> 500px)
  ══════════════════════════════════════════ -->
  <Layout v-if="tamanhoTela > 500">
    <PageHeader :title="`Romaneio #${idData}`" :items="[{text:'Romaneios',href:'/wmsromaneios/list'},{text:'Editar',active:true}]" :status="wmsRomaneioData.status" />

    <Loader v-if="updating" style="min-height: 300px;" />

    <div v-if="!updating" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex gap-2 flex-wrap mb-3">
              <button class="btn btn-outline-primary btn-sm" @click="salvar" v-if="wmsRomaneioData.status === 'EL'">Salvar</button>
              <button class="btn btn-success btn-sm" @click="finalizar" v-if="wmsRomaneioData.status === 'EL'">Finalizar</button>
              <button class="btn btn-outline-danger btn-sm" @click="cancelar" v-if="wmsRomaneioData.status === 'EL'">Cancelar</button>
              <button class="btn btn-outline-secondary btn-sm" @click="imprimirRomaneio">Imprimir Romaneio</button>
              <div v-if="temAssinaturaConferente || temAssinatura || temFoto" style="margin-top:8px; font-size:12px;">
                <span v-if="temAssinaturaConferente" style="color:#27ae60; margin-right:8px;">
                  ✍️ Conferente assinado
                </span>
                <span v-if="temAssinatura" style="color:#27ae60; margin-right:8px;">
                  ✍️ Motorista assinado
                </span>
                <span v-if="temFoto" style="color:#27ae60;">
                  📷 Foto registrada
                </span>
              </div>
              <button class="btn btn-outline-secondary btn-sm" @click="imprimirSepPedPorPage">Sep. Por Página</button>
              <button class="btn btn-outline-secondary btn-sm" @click="imprimirSep">Sep. Geral</button>
              <button class="btn btn-outline-secondary btn-sm" @click="imprimirSepAgr">Sep. Agrupada</button>
              <button class="btn btn-outline-info btn-sm" @click="reenvioEmailEmbarque">Re-enviar E-mail</button>
              <button class="btn btn-outline-secondary btn-sm" @click="novoAnexo">Anexar</button>
              <button class="btn btn-outline-secondary btn-sm" @click="visualizarComprovante">Comprovante</button>
            </div>

            <!-- Info -->
            <div class="row">
              <div class="col-md-4">
                <p><strong>Status:</strong>
                  <select v-model="wmsRomaneioData.status" class="form-select form-select-sm d-inline w-auto ms-2" @change="salvar">
                    <option value="EL">EL - Em Lançamento</option>
                    <option value="EQ">EQ - Em Expedição</option>
                    <option value="FN">FN - Finalizado</option>
                    <option value="CA">CA - Cancelado</option>
                    <option value="SE">SE - Separado</option>
                  </select>
                </p>
                <p><strong>Empresa:</strong> {{ wmsRomaneioData.empresanome }}</p>
                <p><strong>Transportadora:</strong> {{ transpData ? transpData.nome : '-' }}
                  <button class="btn btn-link btn-sm" @click="showModalTransp = true" v-if="wmsRomaneioData.status === 'EL'">Editar</button>
                </p>
                <p><strong>Criado em:</strong> {{ formatDateTime(wmsRomaneioData.created_at) }}</p>
                <p><strong>Obs:</strong> {{ wmsRomaneioData.obs }}</p>
              </div>
              <div class="col-md-4">
                <h6>Documentos ({{ qtdTotalDocumentos }}) / Volumes ({{ qtdTotalVolumes }})</h6>
                <button v-if="!travaAddRemov || usuarioEhAdmin" class="btn btn-outline-primary btn-sm mb-2" @click="showModalAddPedido = true">+ Adicionar Documento</button>
                <div v-for="item in pedidosData" :key="item.id" class="border rounded p-2 mb-2">
                  <div class="d-flex justify-content-between">
                    <span><strong>{{ item.codigo }}</strong> — {{ item.nome }}</span>
                    <div class="d-flex gap-1">
                      <button class="btn btn-outline-secondary btn-sm" @click="abrirModalVol(item)">Vols</button>
                      <button class="btn btn-outline-primary btn-sm" @click="abrirWmsOs(item.wmsosid || item.wmsos_id)">OS</button>
                      <button v-if="!travaAddRemov || usuarioEhAdmin" class="btn btn-outline-danger btn-sm" @click="desvRomPed(item.id)">Desv</button>
                      <button v-if="!travaAddRemov || usuarioEhAdmin" class="btn btn-outline-danger btn-sm" @click="deletarRomPed(item.id)">Remov</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>

  <!-- ═══════════════════════════════════════
       MOBILE (≤ 500px)
  ══════════════════════════════════════════ -->
  <div v-if="tamanhoTela <= 500" class="full-height-wrapper">
    <div class="full-height-card card">
      <div class="full-height-body card-body">

        <!-- HEADER FIXO -->
        <div class="coletor-header">
          <button class="btn-back-header" @click="$router.go(-1)">&#8592;</button>
          <span class="header-title">ROMANEIO #{{ idData }}</span>
          <span class="badge-status" :class="`badge-${wmsRomaneioData.status}`">
            {{ wmsRomaneioData.status }}
          </span>
        </div>

        <!-- LOADER -->
        <div v-if="updating" style="flex:1;display:flex;align-items:center;justify-content:center;padding:20px;">
          <Loader />
        </div>

        <template v-if="!updating">
          <!-- TAB BAR -->
          <div class="tab-bar">
            <div class="tab-item" :class="{active: activeTab===0}" @click="onTabChange(0)">Info</div>
            <div class="tab-item" :class="{active: activeTab===1}" @click="onTabChange(1)">Docs</div>
            <div class="tab-item" :class="{active: activeTab===2}" @click="onTabChange(2)">Vols</div>
            <div class="tab-item" :class="{active: activeTab===3}" @click="onTabChange(3)">Ações</div>
          </div>

          <!-- ────────────────────────────
               TAB 0 — INFO
          ──────────────────────────── -->
          <div class="tab-content" v-show="activeTab === 0">

            <!-- Status -->
            <div class="field-row">
              <div class="field-label">Status</div>
              <select v-model="wmsRomaneioData.status" class="compact-input" @change="salvar">
                <option value="EL">EL — Em Lançamento</option>
                <option value="EQ">EQ — Em Expedição</option>
                <option value="FN">FN — Finalizado</option>
                <option value="CA">CA — Cancelado</option>
                <option value="SE">SE — Separado</option>
              </select>
            </div>

            <!-- Empresa -->
            <div class="field-row">
              <div class="field-label">Empresa</div>
              <div class="field-value">{{ wmsRomaneioData.empresanome || wmsRomaneioData.empresa }}</div>
            </div>

            <!-- Data criação -->
            <div class="field-row">
              <div class="field-label">Criado em</div>
              <div class="field-value">{{ formatDateTime(wmsRomaneioData.created_at) }}</div>
            </div>

            <!-- Transportadora -->
            <div class="field-row">
              <div class="field-label">Transportadora</div>
              <div class="d-flex align-items-center gap-2">
                <span class="field-value" style="flex:1">{{ transpData ? transpData.nome : 'Não definida' }}</span>
                <button v-if="wmsRomaneioData.status === 'EL'" class="btn-doc-action" style="border-color:#007bff;color:#007bff;" @click="showModalTransp = true">Editar</button>
              </div>
            </div>

            <!-- Motorista -->
            <div class="field-row" v-if="wmsRomaneioData.motorista">
              <div class="field-label">Motorista</div>
              <div class="field-value">{{ wmsRomaneioData.motorista }}</div>
            </div>

            <!-- Rota -->
            <div class="field-row" v-if="wmsRomaneioData.rota">
              <div class="field-label">Rota</div>
              <div class="field-value">{{ wmsRomaneioData.rota }}</div>
            </div>

            <!-- Botões de modais de info -->
            <div class="d-flex flex-wrap gap-2 mb-3">
              <button class="btn-doc-action" @click="showModalObs = true">Observações</button>
              <button class="btn-doc-action" @click="showModalRota = true">Rota</button>
              <button class="btn-doc-action" @click="showModalDetalhes = true">Detalhes</button>
            </div>

          </div><!-- /tab-content 0 -->

          <!-- ────────────────────────────
               TAB 1 — DOCS
          ──────────────────────────── -->
          <div class="tab-content" v-show="activeTab === 1">

            <!-- Barra de seleção -->
            <div class="batch-toolbar">
              <div class="d-flex align-items-center justify-content-between">
                <label style="font-size:12px;cursor:pointer;">
                  <input type="checkbox" v-model="selecionarTodos" @change="selecionaTodos" />
                  Selecionar todos
                </label>
                <span style="font-size:11px;color:#555;">{{ totalSelecionado }} sel.</span>
                <button v-if="!travaAddRemov || usuarioEhAdmin" class="btn-doc-action" style="border-color:#28a745;color:#28a745;" @click="showModalAddPedido = true">+ Add</button>
              </div>

              <!-- Ações em lote -->
              <div class="batch-actions" v-if="totalSelecionado > 0">
                <button class="btn-batch" style="border-color:#007bff;color:#007bff;" @click="imprimirMiniDanfeSelecionados">Etiquetas</button>
                <button class="btn-batch" style="border-color:#6f42c1;color:#6f42c1;" @click="imprimirZipDanfe">ZIP DANFE</button>
                <button class="btn-batch" style="border-color:#fd7e14;color:#fd7e14;" @click="disparaColeta">Coleta</button>
                <button class="btn-batch" style="border-color:#20c997;color:#20c997;" @click="plpCorreios">PLP Correios</button>
                <button class="btn-batch" style="border-color:#17a2b8;color:#17a2b8;" @click="gerarWmsOs">Gerar WMS OS</button>
              </div>
            </div>

            <!-- Lista de documentos -->
            <div v-for="item in pedidosData" :key="item.id" class="doc-card">
              <div class="doc-card-header">
                <input type="checkbox" v-model="item.selecionado" @change="atualizarTotalSelecionado" />
                <span class="doc-nf">NF {{ item.codigo }}</span>
                <span class="badge-status" :class="`badge-${item.status || 'EL'}`" style="margin-left:auto;">{{ item.status }}</span>
              </div>
              <div class="doc-cliente">{{ item.nome }}</div>
              <div class="doc-stats">{{ formatDecimal(item.pesototal) }}kg &middot; {{ item.qtdvolumes || 0 }} vol &middot; R$ {{ formatDecimal(item.valorliq) }}</div>
              <div class="doc-actions">
                <button class="btn-doc-action" @click="abrirModalVol(item)">Vols</button>
                <button class="btn-doc-action" @click="abrirWmsOs(item.wmsosid || item.wmsos_id)" v-if="item.wmsosid || item.wmsos_id">OS</button>
                <button class="btn-doc-action" @click="imprimirMiniDanfeItem(item)">DANFE</button>
                <button class="btn-doc-action" @click="imprimirEtiqLogistica(item.chave, item.wmsosid || item.wmsos_id)">Etiq</button>
                <button class="btn-doc-action" @click="dispararColetaIndividual(item)">Coleta</button>
                <button v-if="!travaAddRemov || usuarioEhAdmin" class="btn-doc-action" style="border-color:#dc3545;color:#dc3545;" @click="desvRomPed(item.id)">Desv</button>
                <button v-if="!travaAddRemov || usuarioEhAdmin" class="btn-doc-action" style="border-color:#dc3545;color:#dc3545;" @click="deletarRomPed(item.id)">Remov</button>
                <button class="btn-doc-action" @click="retryBuscarVolumesTagia(item)" v-if="item.flagtagia">Retry Tagia</button>
              </div>
            </div>

            <div v-if="!pedidosData || pedidosData.length === 0" style="text-align:center;padding:20px;color:#888;font-size:13px;">
              Nenhum documento associado.
            </div>

          </div><!-- /tab-content 1 -->

          <!-- ────────────────────────────
               TAB 2 — VOLUMES (EXPEDIÇÃO)
          ──────────────────────────── -->
          <div class="tab-content" v-show="activeTab === 2" style="display:flex;flex-direction:column;overflow:hidden;">

            <!-- Input scan -->
            <div class="scan-input-wrapper">
              <div class="scan-label">Scan Etiqueta (Alt+E)</div>
              <input
                ref="scanInput"
                v-model="scanEtiquetaInput"
                class="compact-input"
                placeholder="Leia ou digite a etiqueta..."
                @keypress.enter="informouEtiquetaNova"
                autocomplete="off"
              />
            </div>

            <!-- Contadores -->
            <div class="d-flex gap-3 mb-2">
              <span style="font-size:12px;"><strong>Pendentes:</strong> {{ itensPendentes.length }}</span>
              <span style="font-size:12px;"><strong>Lidos:</strong> {{ itensLidos.length }}</span>
            </div>

            <!-- Pendentes -->
            <div class="items-section-title">Pendentes ({{ itensPendentes.length }})</div>
            <div style="flex:1;overflow-y:auto;">
              <div v-for="item in itensPendentes" :key="item.id" class="item-pendente"
                   style="cursor:default;">
                <div>
                  <div style="font-size:12px;font-weight:600;">{{ item.codigo }}</div>
                  <div style="font-size:11px;color:#888;">{{ item.nome }} &mdash; {{ item.etiqueta }}</div>
                </div>
              </div>
              <div v-if="itensPendentes.length === 0" style="text-align:center;padding:10px;color:#aaa;font-size:12px;">Nenhum item pendente</div>

              <!-- Lidos -->
              <div class="items-section-title" v-if="itensLidos.length > 0">Lidos ({{ itensLidos.length }})</div>
              <div v-for="item in itensLidos" :key="`lido-${item.id}`" class="item-lido">
                {{ item.etiqueta }} &mdash; {{ item.codigo }}
              </div>
            </div>

            <!-- Footer de ações expedição -->
            <div class="exp-footer">
              <button class="btn-exp btn-exp-warning" @click="separarTodos">Separar Todos</button>
              <button class="btn-exp btn-exp-danger" @click="reiniciarExpedicao">Reiniciar</button>
              <button class="btn-exp btn-exp-success" @click="finalizarExpedicao">Finalizar</button>
            </div>

          </div><!-- /tab-content 2 -->

          <!-- ────────────────────────────
               TAB 3 — AÇÕES
          ──────────────────────────── -->
          <div class="tab-content" v-show="activeTab === 3">

            <div class="action-group-title">Finalização</div>
            <button class="btn-action btn-action-success" @click="finalizar" v-if="wmsRomaneioData.status === 'EL'">&#10003; Finalizar Romaneio</button>
            <button class="btn-action btn-action-danger" @click="cancelar" v-if="wmsRomaneioData.status === 'EL'">&#10007; Cancelar Romaneio</button>

            <div class="action-group-title">Impressão</div>
            <button class="btn-action btn-action-primary" @click="imprimirRomaneio">Imprimir Romaneio</button>
            <div v-if="temAssinaturaConferente || temAssinatura || temFoto" style="margin-top:8px; font-size:12px;">
              <span v-if="temAssinaturaConferente" style="color:#27ae60; margin-right:8px;">
                ✍️ Conferente assinado
              </span>
              <span v-if="temAssinatura" style="color:#27ae60; margin-right:8px;">
                ✍️ Motorista assinado
              </span>
              <span v-if="temFoto" style="color:#27ae60;">
                📷 Foto registrada
              </span>
            </div>
            <button class="btn-action btn-action-secondary" @click="imprimirSepPedPorPage">Separação por Página</button>
            <button class="btn-action btn-action-secondary" @click="imprimirSep">Separação Geral</button>
            <button class="btn-action btn-action-secondary" @click="imprimirSepAgr">Separação Agrupada</button>
            <button class="btn-action btn-action-secondary" @click="imprimirMiniDanfeSelecionados">Mini-DANFE Selecionados</button>
            <button class="btn-action btn-action-secondary" @click="imprimirZipDanfe">Baixar ZIP DANFE</button>

            <div class="action-group-title">Logística</div>
            <button class="btn-action btn-action-primary" @click="showModalImprimirEtiqLogistica = true">Etiquetas Logísticas</button>
            <button class="btn-action btn-action-secondary" @click="plpCorreios">PLP Correios</button>
            <button class="btn-action btn-action-secondary" @click="disparaColeta">Solicitar Coleta (selecionados)</button>
            <button class="btn-action btn-action-secondary" @click="exportarColeta">Exportar Coleta (Excel)</button>
            <button class="btn-action btn-action-secondary" @click="reenvioEmailEmbarque">Reenviar E-mail Embarque</button>
            <button class="btn-action btn-action-secondary" @click="gerarWmsOs">Gerar WMS OS</button>

            <div class="action-group-title">Anexos</div>
            <button class="btn-action btn-action-primary" @click="novoAnexo">+ Adicionar Anexo</button>
            <button class="btn-action btn-action-secondary" @click="visualizarComprovante">Baixar Comprovante</button>

          </div><!-- /tab-content 3 -->

        </template><!-- /!updating -->
      </div><!-- /full-height-body -->
    </div><!-- /full-height-card -->

    <!-- ════════════════════════════════════
         MODAIS MOBILE
    ════════════════════════════════════ -->

    <!-- MODAL TRANSPORTADORA -->
    <div v-if="showModalTransp" class="modal-overlay" @click.self="showModalTransp = false">
      <div class="modal-mobile">
        <div class="modal-mobile-header">
          <span>Transportadora</span>
          <button class="modal-close" @click="showModalTransp = false">&#10005;</button>
        </div>
        <div class="modal-mobile-body">
          <Multiselect
            v-model="wmsRomaneioData.transp"
            :options="dtListPesqTransp || []"
            :searchable="true"
            label="nome"
            valueProp="cnpj"
            placeholder="Buscar transportadora..."
            :filterResults="false"
            :min-chars="2"
            @search-change="pesqTransp"
            @select="escolheuTransp"
            noOptionsText="Digite para buscar"
            noResultsText="Nenhuma encontrada"
          />
          <div v-if="loadingTransp" style="text-align:center;padding:10px;font-size:12px;color:#888;">Carregando...</div>
        </div>
        <div class="modal-mobile-footer">
          <button class="btn-action btn-action-primary" @click="confirmarTransp">Confirmar</button>
        </div>
      </div>
    </div>

    <!-- MODAL OBSERVAÇÕES -->
    <div v-if="showModalObs" class="modal-overlay" @click.self="showModalObs = false">
      <div class="modal-mobile">
        <div class="modal-mobile-header">
          <span>Observações</span>
          <button class="modal-close" @click="showModalObs = false">&#10005;</button>
        </div>
        <div class="modal-mobile-body">
          <textarea v-model="wmsRomaneioData.obs" class="compact-input" rows="5" style="height:auto;resize:none;" placeholder="Digite a observação..."></textarea>
        </div>
        <div class="modal-mobile-footer">
          <button class="btn-action btn-action-primary" @click="confirmarObs">Salvar</button>
        </div>
      </div>
    </div>

    <!-- MODAL ROTA -->
    <div v-if="showModalRota" class="modal-overlay" @click.self="showModalRota = false">
      <div class="modal-mobile">
        <div class="modal-mobile-header">
          <span>Rota</span>
          <button class="modal-close" @click="showModalRota = false">&#10005;</button>
        </div>
        <div class="modal-mobile-body">
          <div class="field-label">Rota</div>
          <input v-model="wmsRomaneioData.rota" class="compact-input" placeholder="Informe a rota..." />
        </div>
        <div class="modal-mobile-footer">
          <button class="btn-action btn-action-primary" @click="confirmarRota">Salvar</button>
        </div>
      </div>
    </div>

    <!-- MODAL DETALHES -->
    <div v-if="showModalDetalhes" class="modal-overlay" @click.self="showModalDetalhes = false">
      <div class="modal-mobile">
        <div class="modal-mobile-header">
          <span>Detalhes</span>
          <button class="modal-close" @click="showModalDetalhes = false">&#10005;</button>
        </div>
        <div class="modal-mobile-body">
          <div class="field-row">
            <div class="field-label">Placa</div>
            <input v-model="wmsRomaneioData.placa" class="compact-input" placeholder="Placa do veículo" />
          </div>
          <div class="field-row">
            <div class="field-label">Motorista</div>
            <input v-model="wmsRomaneioData.motorista" class="compact-input" placeholder="Nome do motorista" />
          </div>
          <div class="field-row">
            <div class="field-label">CPF Motorista</div>
            <input v-model="wmsRomaneioData.cpfmotorista" class="compact-input" placeholder="CPF" />
          </div>
        </div>
        <div class="modal-mobile-footer">
          <button class="btn-action btn-action-primary" @click="confirmarDetalhes">Salvar</button>
        </div>
      </div>
    </div>

    <!-- MODAL ADICIONAR DOCUMENTO -->
    <div v-if="showModalAddPedido" class="modal-overlay" @click.self="showModalAddPedido = false">
      <div class="modal-mobile">
        <div class="modal-mobile-header">
          <span>Adicionar Documento</span>
          <button class="modal-close" @click="showModalAddPedido = false">&#10005;</button>
        </div>
        <div class="modal-mobile-body">
          <!-- Tabs internas -->
          <div class="tab-bar" style="margin-bottom:10px;">
            <div class="tab-item" :class="{active: modoPesq==='chavenf'}" @click="modoPesq='chavenf'">Chave NFe</div>
            <div class="tab-item" :class="{active: modoPesq==='nf'}" @click="modoPesq='nf'">Nº NFe</div>
            <div class="tab-item" :class="{active: modoPesq==='wmsos'}" @click="modoPesq='wmsos';showModalAddWmsOs=true;showModalAddPedido=false">Por OS</div>
          </div>
          <div v-if="modoPesq === 'chavenf'">
            <div class="field-label">Chave NF-e (44 dígitos)</div>
            <input v-model="chaveAddNf" class="compact-input" placeholder="Chave NF-e" maxlength="44" />
          </div>
          <div v-if="modoPesq === 'nf'">
            <div class="field-label">Número NF</div>
            <input v-model="chaveAddNf" class="compact-input" placeholder="Número da NF" />
          </div>
        </div>
        <div class="modal-mobile-footer">
          <button class="btn-action btn-action-primary" @click="confirmarAddPedido">Adicionar</button>
        </div>
      </div>
    </div>

    <!-- MODAL ADICIONAR POR OS -->
    <div v-if="showModalAddWmsOs" class="modal-overlay" @click.self="showModalAddWmsOs = false">
      <div class="modal-mobile">
        <div class="modal-mobile-header">
          <span>Adicionar por OS</span>
          <button class="modal-close" @click="showModalAddWmsOs = false">&#10005;</button>
        </div>
        <div class="modal-mobile-body">
          <div class="field-label">ID da Ordem de Saída</div>
          <input v-model="idWmsOs" class="compact-input" type="number" placeholder="ID da WMS OS" />
        </div>
        <div class="modal-mobile-footer">
          <button class="btn-action btn-action-primary" @click="confirmarAddWmsOs">Adicionar</button>
        </div>
      </div>
    </div>

    <!-- MODAL VOLUMES DE OS -->
    <div v-if="showModalVolume" class="modal-overlay" @click.self="showModalVolume = false">
      <div class="modal-mobile" style="max-height:85vh;overflow-y:auto;">
        <div class="modal-mobile-header">
          <span>Volumes da OS</span>
          <button class="modal-close" @click="showModalVolume = false">&#10005;</button>
        </div>
        <div class="modal-mobile-body">
          <!-- Tabela de volumes -->
          <table style="width:100%;font-size:12px;border-collapse:collapse;" v-if="wmsOsVolumesData && wmsOsVolumesData.length">
            <thead>
              <tr style="background:#f8f9fa;">
                <th style="padding:4px 6px;text-align:left;">ID</th>
                <th style="padding:4px 6px;text-align:left;">Etiqueta</th>
                <th style="padding:4px 6px;text-align:right;">Peso</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="vol in wmsOsVolumesData" :key="vol.id" style="border-bottom:1px solid #f0f0f0;">
                <td style="padding:4px 6px;">{{ vol.id }}</td>
                <td style="padding:4px 6px;">{{ vol.etiqueta }}</td>
                <td style="padding:4px 6px;text-align:right;">{{ formatDecimal(vol.peso) }}</td>
              </tr>
              <tr style="background:#f8f9fa;font-weight:700;">
                <td colspan="2" style="padding:4px 6px;text-align:right;">Total:</td>
                <td style="padding:4px 6px;text-align:right;">{{ formatDecimal(somaPesoVolumes) }}</td>
              </tr>
            </tbody>
          </table>
          <div v-else style="text-align:center;padding:10px;color:#888;font-size:12px;">Nenhum volume cadastrado.</div>

          <!-- Adicionar volume -->
          <div style="margin-top:12px;border-top:1px solid #eee;padding-top:10px;">
            <div class="action-group-title">Adicionar Volume</div>
            <div class="d-flex gap-2">
              <div style="flex:1">
                <div class="field-label">Qtd</div>
                <input v-model.number="wmsOsVolumeData.qtd" type="number" class="compact-input" placeholder="Qtd" min="1" />
              </div>
              <div style="flex:1">
                <div class="field-label">Peso (kg)</div>
                <input v-model.number="wmsOsVolumeData.peso" type="number" class="compact-input" placeholder="Peso" min="0" step="0.01" />
              </div>
            </div>
          </div>

          <div v-if="loadingWmsVolume" style="text-align:center;padding:10px;color:#888;">Salvando...</div>
        </div>
        <div class="modal-mobile-footer">
          <button class="btn-action btn-action-secondary" @click="imprimirEtiquetasVolume({wmsosid: idWmsOsSelecionado})">Imprimir Todas</button>
          <button class="btn-action btn-action-primary" @click="confirmarVolume" :disabled="!wmsOsVolumeData.qtd || wmsOsVolumeData.qtd <= 0 || !wmsOsVolumeData.peso || wmsOsVolumeData.peso <= 0">+ Confirmar Volume</button>
        </div>
      </div>
    </div>

    <!-- MODAL PLP CORREIOS -->
    <div v-if="showModalPLPCorreios" class="modal-overlay" @click.self="showModalPLPCorreios = false">
      <div class="modal-mobile" style="max-height:90vh;overflow-y:auto;">
        <div class="modal-mobile-header">
          <span>PLP Correios</span>
          <button class="modal-close" @click="showModalPLPCorreios = false">&#10005;</button>
        </div>
        <div class="modal-mobile-body">
          <div class="d-flex gap-2">
            <div style="flex:1">
              <div class="field-label">Formato</div>
              <select v-model="movPlpLoteData.formato" class="compact-input">
                <option value="1">Caixa/Pacote</option>
                <option value="2">Rolo/Prisma</option>
                <option value="3">Envelope</option>
              </select>
            </div>
            <div style="flex:1">
              <div class="field-label">Serviço</div>
              <input v-model="movPlpLoteData.servico" class="compact-input" placeholder="Cód. serviço" />
            </div>
          </div>
          <div class="d-flex gap-2 mt-2">
            <div style="flex:1">
              <div class="field-label">Altura (cm)</div>
              <input v-model.number="movPlpLoteData.altuinf" type="number" class="compact-input" />
            </div>
            <div style="flex:1">
              <div class="field-label">Largura (cm)</div>
              <input v-model.number="movPlpLoteData.larginf" type="number" class="compact-input" />
            </div>
            <div style="flex:1">
              <div class="field-label">Comp. (cm)</div>
              <input v-model.number="movPlpLoteData.compinf" type="number" class="compact-input" />
            </div>
          </div>
          <div class="d-flex gap-2 mt-2">
            <div style="flex:1">
              <div class="field-label">Peso (kg)</div>
              <input v-model.number="movPlpLoteData.pesoinf" type="number" class="compact-input" step="0.01" />
            </div>
            <div style="flex:1">
              <div class="field-label">Prev. Postagem</div>
              <input v-model="movPlpLoteData.prevpost" type="date" class="compact-input" />
            </div>
          </div>

          <div v-if="loadingMovPlp" style="text-align:center;padding:10px;color:#888;font-size:12px;">Processando...</div>

          <!-- Lotes existentes -->
          <div v-if="movPlpLotesData" style="margin-top:12px;border-top:1px solid #eee;padding-top:10px;">
            <div class="action-group-title">Lote Atual</div>
            <div style="font-size:12px;">ID: {{ movPlpLotesData.id }} &mdash; Status: {{ movPlpLotesData.descstatus }}</div>
            <div class="d-flex gap-2 mt-2 flex-wrap">
              <button class="btn-doc-action" @click="solicitarRotuloLote(movPlpLotesData.id)">Solicitar Etiqueta</button>
              <button class="btn-doc-action" @click="consultarTodosObjetos(movPlpLotesData.id)">Consultar Objetos</button>
              <button class="btn-doc-action" style="border-color:#dc3545;color:#dc3545;" @click="cancelarMovPlp(movPlpLotesData.id)">Cancelar</button>
            </div>
          </div>
        </div>
        <div class="modal-mobile-footer">
          <button class="btn-action btn-action-primary" @click="confPLPLoteCorreios" :disabled="loadingMovPlp">Solicitar PLP</button>
        </div>
      </div>
    </div>

    <!-- MODAL ETIQUETA LOGÍSTICA (BUSCA) -->
    <div v-if="showModalImprimirEtiqLogistica" class="modal-overlay" @click.self="showModalImprimirEtiqLogistica = false">
      <div class="modal-mobile">
        <div class="modal-mobile-header">
          <span>Etiqueta Logística</span>
          <button class="modal-close" @click="showModalImprimirEtiqLogistica = false">&#10005;</button>
        </div>
        <div class="modal-mobile-body">
          <div class="field-label">Chave / Número NF</div>
          <input v-model="chaveEtiqLogistica" class="compact-input" placeholder="Chave ou número da NF" @keypress.enter="buscarEtiqLogistica" />
        </div>
        <div class="modal-mobile-footer">
          <button class="btn-action btn-action-primary" @click="buscarEtiqLogistica">Buscar e Imprimir</button>
        </div>
      </div>
    </div>

    <!-- MODAL VISUALIZAR PDF ETIQUETA LOGÍSTICA -->
    <div v-if="showModalEtiquetaLogistica" class="modal-overlay" @click.self="showModalEtiquetaLogistica = false">
      <div class="modal-mobile" style="max-height:90vh;">
        <div class="modal-mobile-header">
          <span>Etiqueta Logística</span>
          <button class="modal-close" @click="showModalEtiquetaLogistica = false">&#10005;</button>
        </div>
        <div class="modal-mobile-body" style="padding:0;flex:1;">
          <iframe :src="pdfUrl" style="width:100%;height:400px;border:none;"></iframe>
        </div>
      </div>
    </div>

    <!-- MODAL ANEXO -->
    <div v-if="showModalAnexo" class="modal-overlay" @click.self="showModalAnexo = false">
      <div class="modal-mobile">
        <div class="modal-mobile-header">
          <span>Adicionar Anexo</span>
          <button class="modal-close" @click="showModalAnexo = false">&#10005;</button>
        </div>
        <div class="modal-mobile-body">
          <div class="field-label">Arquivo</div>
          <input ref="fileInput" type="file" class="compact-input" style="height:auto;padding:4px;" />
          <div class="field-label mt-2">Descrição</div>
          <input v-model="descranexo" class="compact-input" placeholder="Descrição do anexo" />
          <div v-if="submittedAnexo && !descranexo" style="color:#dc3545;font-size:11px;">Descrição obrigatória.</div>
        </div>
        <div class="modal-mobile-footer">
          <button class="btn-action btn-action-primary" @click="confAnexo" :disabled="loadingFiles">
            {{ loadingFiles ? 'Enviando...' : 'Enviar Anexo' }}
          </button>
        </div>
      </div>
    </div>


  </div><!-- /full-height-wrapper -->

  <!-- Always rendered — outside both branches -->
  <!-- Input oculto para captura de foto comprovante -->
  <input
    ref="inputFoto"
    type="file"
    accept="image/*"
    capture="environment"
    style="display:none"
    @change="aoSelecionarFoto"
  />

  <!-- Modal fullscreen de assinatura digital -->
  <SignaturePadModal
    v-if="mostrarAssinatura"
    :titulo="tipoAssinatura === 'conferente' ? 'Assinatura do Conferente' : 'Assinatura do Motorista'"
    @confirmada="aoConfirmarAssinatura"
    @cancelar="mostrarAssinatura = false"
  />

</div><!-- root -->
</template>

<style scoped>
/* ── Layout base ── */
.full-height-wrapper { height: 100vh; overflow: hidden; padding: 0; }
.full-height-card { height: 100%; margin: 0; border-radius: 0; display: flex; flex-direction: column; }
.full-height-body { flex: 1; display: flex; flex-direction: column; overflow: hidden; padding: 0; }

/* ── Header ── */
.coletor-header { display: flex; align-items: center; padding: 8px 10px; background: #f8f9fa; border-bottom: 1px solid #dee2e6; gap: 8px; flex-shrink: 0; }
.btn-back-header { background: none; border: none; font-size: 18px; cursor: pointer; color: #6c757d; padding: 0 4px; }
.header-title { font-weight: 700; font-size: 14px; flex: 1; }

/* ── Tabs ── */
.tab-bar { display: flex; border-bottom: 2px solid #dee2e6; flex-shrink: 0; background: white; }
.tab-item { flex: 1; padding: 8px 4px; text-align: center; font-size: 11px; font-weight: 600; cursor: pointer; color: #6c757d; border-bottom: 2px solid transparent; margin-bottom: -2px; }
.tab-item.active { color: #007bff; border-bottom-color: #007bff; }

/* ── Conteúdo ── */
.tab-content { flex: 1; overflow-y: auto; padding: 10px; }

/* ── Campos ── */
.field-row { margin-bottom: 10px; }
.field-label { font-size: 11px; color: #888; margin-bottom: 2px; }
.field-value { font-size: 13px; font-weight: 500; }
.compact-input { font-size: 12px; padding: 4px 6px; height: 32px; border-radius: 3px; border: 1px solid #ddd; width: 100%; box-sizing: border-box; }
.compact-input:focus { border-color: #007bff; outline: none; box-shadow: 0 0 0 1px rgba(0,123,255,.25); }

/* ── Badges de status ── */
.badge-status { font-size: 10px; padding: 2px 7px; border-radius: 3px; font-weight: 600; }
.badge-EL { background: #cff4fc; color: #055160; }
.badge-EQ { background: #cfe2ff; color: #084298; }
.badge-FN { background: #d1e7dd; color: #0a3622; }
.badge-CA { background: #f8d7da; color: #842029; }
.badge-SE { background: #e2e3e5; color: #41464b; }

/* ── Botões de ação ── */
.btn-action { display: block; width: 100%; padding: 10px 12px; margin-bottom: 8px; border-radius: 5px; border: 1px solid; font-size: 13px; font-weight: 500; text-align: left; background: white; cursor: pointer; }
.btn-action-danger { border-color: #dc3545; color: #dc3545; }
.btn-action-primary { border-color: #007bff; color: #007bff; }
.btn-action-success { border-color: #28a745; color: #28a745; }
.btn-action-secondary { border-color: #6c757d; color: #6c757d; }
.action-group-title { font-size: 11px; font-weight: 700; color: #888; text-transform: uppercase; letter-spacing: 0.5px; margin: 12px 0 6px; }

/* ── Documentos ── */
.doc-card { border: 1px solid #e0e0e0; border-radius: 6px; padding: 10px; margin-bottom: 8px; }
.doc-card-header { display: flex; align-items: center; gap: 6px; margin-bottom: 6px; }
.doc-nf { font-weight: 700; font-size: 13px; }
.doc-cliente { font-size: 12px; color: #555; margin-bottom: 4px; }
.doc-stats { font-size: 11px; color: #888; margin-bottom: 6px; }
.doc-actions { display: flex; flex-wrap: wrap; gap: 4px; }
.btn-doc-action { font-size: 10px; padding: 3px 7px; border: 1px solid #ccc; border-radius: 3px; background: white; cursor: pointer; white-space: nowrap; }

/* ── Scan / Volumes ── */
.scan-input-wrapper { margin-bottom: 12px; flex-shrink: 0; }
.scan-label { font-size: 11px; color: #888; margin-bottom: 4px; }
.items-section-title { font-size: 12px; font-weight: 700; margin: 10px 0 6px; flex-shrink: 0; }
.item-pendente { display: flex; align-items: center; justify-content: space-between; padding: 8px 0; border-bottom: 1px solid #f0f0f0; font-size: 12px; }
.item-lido { padding: 6px 0; border-bottom: 1px solid #f0f0f0; font-size: 12px; color: #555; }
.exp-footer { display: flex; gap: 6px; padding-top: 10px; border-top: 1px solid #eee; flex-shrink: 0; }
.btn-exp { flex: 1; padding: 8px; font-size: 11px; font-weight: 600; border-radius: 4px; border: 1px solid; cursor: pointer; background: white; }
.btn-exp-warning { border-color: #ffc107; color: #856404; }
.btn-exp-danger { border-color: #dc3545; color: #dc3545; }
.btn-exp-success { border-color: #28a745; color: #28a745; }

/* ── Batch toolbar ── */
.batch-toolbar { background: #e8f4fd; border-radius: 6px; padding: 8px; margin-bottom: 8px; }
.batch-actions { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 6px; }
.btn-batch { font-size: 11px; padding: 4px 8px; border: 1px solid; border-radius: 3px; background: white; cursor: pointer; }

/* ── Modais mobile ── */
.modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: flex-end; justify-content: center; }
.modal-mobile { background: white; width: 100%; max-width: 500px; border-radius: 12px 12px 0 0; display: flex; flex-direction: column; max-height: 85vh; }
.modal-mobile-header { display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; border-bottom: 1px solid #eee; font-size: 14px; font-weight: 700; flex-shrink: 0; }
.modal-close { background: none; border: none; font-size: 16px; cursor: pointer; color: #888; }
.modal-mobile-body { flex: 1; overflow-y: auto; padding: 12px 14px; }
.modal-mobile-footer { padding: 10px 14px; border-top: 1px solid #eee; flex-shrink: 0; }

/* ── Helpers ── */
.mt-2 { margin-top: 8px; }
.d-flex { display: flex; }
.gap-2 { gap: 8px; }
.gap-3 { gap: 12px; }
.flex-wrap { flex-wrap: wrap; }
.align-items-center { align-items: center; }
.justify-content-between { justify-content: space-between; }
.mb-2 { margin-bottom: 8px; }
.mb-3 { margin-bottom: 12px; }
</style>
